export default "__VITE_ASSET__IsJseZqc__"